// tslint:disable:max-line-length

import React from 'react';

export const TransactionCreditCard = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0.5,2C0.2,2,0,2.2,0,2.5V4h16V2.5C16,2.2,15.8,2,15.5,2H0.5z M0,6v7.5C0,13.8,0.2,14,0.5,14h15c0.3,0,0.5-0.2,0.5-0.5V6H0z M2,10h3v2H2V10z" />
    </svg>
  );
};
